<template>
  <div id="search" style="margin-top: 5rem;">
    <div>
        <!-- https://unsplash.com/photos/SqsbTuo5jP0 -->
        <b-img src="/public/downloads/directories/images/searching.jpg" fluid alt="Search"></b-img>
    </div>
    <h2>Dokumenten-Suche</h2>
    <div>
      <b-form-input v-model="searchTerm" type="search" placeholder="Geben Sie den Suchbegriff ein"></b-form-input>
      <b-button variant="success" @click="search" style="margin-top: 2rem;" >Suche</b-button>
    </div>

    <div v-for="doc in searchResults" :key="doc.fileName" style="margin-top: 5rem;">
        <ul style="display: inline-block; text-align: left">
            <li><b>Dateiname:</b> {{doc.fileName}}<br/><br clear="left"></li>
        </ul>
    </div>

    <div v-if="searching" style="margin-top: 3rem;">
        Searching...
    </div>


    <div v-if="noResults" style="margin-top: 3rem;">
       Mist, leider nichts gefunden. Nächster Versuch...
    </div>

  </div>
</template>

<script>
  import {SEARCH_REQUEST} from '@/store/actions/search'
  // TODO : can we remove this line?
  import store from '@/store'
  // TODO : can we remove this line?
  import { mapState } from 'vuex'

  export default {
    name: 'search',
    data () {
         console.log("Returning data");
         return {
            searchTerm:'',
            noResults:false,
            firstSearch:true
          }
    },
    mounted () {

    },
    // https://vuejs.org/v2/guide/computed.html : debounced!
    methods: {
        search:function() {
              this.setResult(false);
              this.$store.dispatch(SEARCH_REQUEST, encodeURIComponent(this.searchTerm));
        },
        setResult: function(bool) {
            this.noResults = bool;
        }
    },
    computed: {
        searchResults: function() {
          let docSearchResults = this.$store.getters.getSearchResults;
          this.setResult(this.firstSearch === false && this.searchTerm != '' && docSearchResults.length === 0);
          return docSearchResults;
        },
        searching: function() {
            return this.$store.getters.getSearching;
        }
    },
    watch: {
        searching: function(newValue, oldValue) {
            if (newValue === false && oldValue === true) {
                this.firstSearch = false;
            }
        }
    }
  }

</script>